/**
 * Returns marketing attributes for URLs without PII or UGC on Trello hybrid marketing/product pages. Use in GAS
 * analytics events when `{isMarketingEvent: true}` exists in the attributes : {...}.
 * 
 * @example
 * //returns marketing attributes as an object to include with existing attributes.
 * const marketingAttributes = getMarketingAttributes();
    
    Analytics.sendScreenEvent({
      name: 'boardScreen',
      attributes: {
        isMarketingEvent: true,
        ...marketingAttributes,
      },
    });
 *
 */

interface MarketingAttributes {
  writeKey: string;
}

export const getMarketingAttributes = (): MarketingAttributes => {
  return { writeKey: 'trello' };
};
